var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agent-clients"},_vm._l((_vm.agentClients),function(client,index){return _c('div',{key:index,staticClass:"agent-clients-wrap"},[_c('list-client',{attrs:{"client":client}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }